export interface Config {
  path?: Record<string, string | null>;
}

/**
 * Transforms a URL by replacing its path and query parameters with values provided in the config.
 *
 * @param url - The URL to be transformed.
 * @param config - An object containing the path and query parameters to be replaced in the URL.
 * @returns The transformed URL.
 */
const transformUrlUtil = (url: string, config?: Config): string[] =>
  url
    .split('/')
    .filter(Boolean)
    .map((segment) => {
      if (!segment.startsWith(':')) {
        return segment;
      }

      const key = segment.replace(':', '');
      const value = config?.path?.[key];

      if (!value) {
        throw new Error(`Missing path parameter: ${key}`);
      }

      return value;
    });

export default transformUrlUtil;
